<template>
  <div>
    <Form ref="form" :onSubmit="onSubmit" :onSuccess="onSuccess">
      <TextReadonly :label="lang.contract_number" :model="contract" name="contract_number" />
      <TextReadonly :label="lang.order_number" :model="contract" name="order_number" />
      <DatePicker
        :label="lang.start_datetime"
        :model="contract"
        name="start_datetime"
        :disabled="true"
      />

      <DatePicker :label="lang.end_date" :model="contract" name="end_datetime" :disabled="true" />
      <DateDifferenceInput
        ref="dateDifferenceInput"
        :label="lang.num_of_days"
        :model="contract"
        :round="true"
        start="start_datetime"
        end="end_datetime"
        name="num_of_days"
        :disabled="true"
      />
      <hr />

      <DatePicker
        ref="endDatetimeDatepicker"
        :label="lang.extension.extend_to"
        :model="model"
        name="end_datetime"
        @change="onEndDatetimeChange"
        :disabled="model.id ? true : false"
        :min="end_datetime_settings.min_date"
        :max="end_datetime_settings.max_date"
        :disabledHours="end_datetime_settings.disabled_hours"
        :noWeekendsDays="end_datetime_settings.no_weekend_days"
        :disabledDates="end_datetime_settings.disabled_dates"
      />

      <DateDifferenceInput
        ref="dateDifferenceInput"
        :label="lang.extension.num_of_days"
        :model="model"
        start="start_datetime"
        :round="true"
        :is_business_days_only="true"
        end="end_datetime"
        @change="onTimeDiffChange"
      />
      <TextInput :label="lang.extension.reason" :model="model" name="reason" multiline="true" />

      <Select
        :required="true"
        :label="lang.extension.bill_to"
        :options="billed_to_options"
        :model="model"
        name="billed_to"
      />

      <TextInput :required="true" :label="lang.signature" :model="model" name="signature" />

      <div class="buttons float-right">
        <button class="btn btn-danger" @click="onCancelClick">{{ i18n.app.common.cancel }}</button>
        <button
          type="submit"
          class="btn btn-success"
          @click="onSubmitClick"
        >{{ i18n.app.common.extend }}</button>
      </div>
    </Form>
  </div>
</template>

<script>
import {
  Form,
  TextReadonly,
  DatePicker,
  FormControl,
  DateDifferenceInput,
  TextInput,
  Select
} from "@/components/common/form";
import ContractExtensionService from "@/services/ContractExtensionService";
import ContractExtension from "@/models/ContractExtension";
import toWeekday from "@/helpers/toWeekday";

export default {
  name: "contract-extend-form",
  props: ["contract"],
  components: {
    Form,
    TextReadonly,
    DatePicker,
    FormControl,
    DateDifferenceInput,
    TextInput,
    Select
  },
  data() {
    return {
      billed_to_options: [],
      end_datetime_settings: {},
      model: new ContractExtension({
        start_datetime: this.contract.end_datetime,

      }),
      contractExtensionService: new ContractExtensionService(this.contract.id),
      lang: i18n.app.components.contract
    };
  },
  mounted() {
    this.model.end_datetime = toWeekday(new Date(
      this.model.start_datetime.getTime() + 24 * 60 * 60 * 1000
    ));

    this.contractExtensionService.create().then(data => {
      this.billed_to_options = data.billed_to_options;
      this.end_datetime_settings = data.end_datetime_settings;
    });

    this.$refs.dateDifferenceInput?.recalcDifference();
    this.$refs.endDatetimeDatepicker?.$forceUpdate();
  },
  methods: {
    onEndDatetimeChange() {
      this.$refs.dateDifferenceInput.recalcDifference();
    },
    onTimeDiffChange(end) {
      this.model.end_datetime = toWeekday(end);
      this.$refs.endDatetimeDatepicker.$forceUpdate();
      this.$refs.dateDifferenceInput.recalcDifference();

    },
    onSubmitClick() {
      this.$refs.form.submit(this.model);
    },
    onSubmit(model) {
      return this.contractExtensionService.insert(model);
    },
    onSuccess(model) {
      this.$bvModal.hide("contract-extend-modal");
      this.$emit("save", model);
    },
    onCancelClick() {
      this.$bvModal.hide("contract-extend-modal");
    }
  }
};
</script>
